var app = angular.module('harriApp');

app.directive('shortListBtn', ['ShortListAPI','ShortListData','hUser','$timeout','$compile', function ( ShortListAPI,ShortListData,hUser,$timeout, $compile ) {


    var shortListBtnsTimplates = {
        'addToShortList' :  '<button class="btn h-md-blue-solid-btn shortlist-btn member-{{userId}}" ng-click="addToShortList()">{{ "Add to Shortlist" | translate }}</button>',
        'alreadyAddedToShortList'  :  '<button class="btn h-md-green-solid-btn no-pointer shortlist-btn member-{{userId}}"><i class="fa fa-check-circle-o"></i> {{ "Shortlisted" | translate }}</button>'
    };

    return {
        restrict: 'A',
        replace : true,
        scope : {
            isShortlisted : '=',
            userId: '=',
            userName: '='
        },
        link: function (scope, iElement, iAttrs) {

            $timeout(function(){
                if ( scope.isShortlisted ) {
                    iElement.html( shortListBtnsTimplates.alreadyAddedToShortList );
                }else{
                    iElement.html( shortListBtnsTimplates.addToShortList );
                }
                $compile( iElement.contents() )( scope );
            });


          /**
           * Add member to ShortList
           */
            scope.addToShortList = function(){

              /* Check if the user loggedin and is Employer */
              if( !hUser.isLoggedIn() ){
                //  display not logged in user
                $('#unloggedin-user .modal').modal('show');
                return;
              }else if(hUser.isLoggedIn() && !hUser.data.user.user_employer){
                // display user is not employer
                $('#not-employer-user .modal').modal('show');
                return;
              }

              $('.member-'+scope.userId).button('loading');


                const brandId = hUser.isEmployer() && hUser.getUserContext().brand_id;


              ShortListAPI.addMembers([scope.userId], brandId).then((resp) => {

                if( resp.data.status_code == 200 ){

                  ShortListData.listIds.push( scope.userId );
                  ShortListData.membersCount = ShortListData.listIds.length;
                  ShortListData.broadcastData();

                  $('.member-'+scope.userId).button('reset');
                  scope.replaceHtml( shortListBtnsTimplates.alreadyAddedToShortList );

                  $timeout(function(){
                    scope.$apply();
                  });
                }
              }).catch((error) => {
                  if (error?.message === BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY) {
                      hAlert({
                          title: $filter("translate")("Error"),
                          text: scope.userName + ' ' + $filter("translate")("has an employment profile under your account, please add their profile directly to the talent pool instead."),
                      });
                  } else {
                      hAlert({
                          title: $filter("translate")("Error"),
                          text: $filter("translate")("An unexpected error occurred. Please try again."),
                      });
                  }

                  $('.member-' + scope.userId).button('reset');
                  scope.replaceHtml(shortListBtnsTimplates.addToShortList);
              });

            }


            scope.replaceHtml = function( htmlTemplate ){
                iElement.html( htmlTemplate );
                $compile( iElement.contents() )( scope );
            }



            scope.$on('Shortlist.InviteToApply',function(){
                scope.replaceHtml( shortListBtnsTimplates.addToShortList );
            });

        }
    };
}])
